import Axios from "axios";
import { getPathName, getApiHash, getApiToken } from "./helper";

export const guardarArchivoSiniestro = async (idSiniestro: string, file: string, type: string = "image") => {
    const headers = {
        'content-type': 'application/json',
        "Authorization": 'Bearer ' + await getApiToken()
    }

    const params = {
        hash: await getApiHash(),
        mediaFiles: {
            Id: idSiniestro,
            Data: file,
            Entidad: "Services",
            Tipo: type === "image" ? "imagen" : "documento"
            //Tipo: "imagen"
        }
    };

    const axiosPostRequest = async () => {
        return Axios.post( await getPathName() + "/SetMediaFormulariosSiniestroVehiculosJSON", params, {
            headers: headers
        });
    };

    try {
        const response = await axiosPostRequest();
        return response;
    } catch (error: any) {
        console.error('Fallo de hacer varios intentos: ' + error.message);
        return error;
    }
}